
<template>
    <div class="underLogoPhrase">
        <h2 class="font-weight-bold mb-4 centers">Mentions legales</h2>

    </div>



</template>


